export default ["M20 10.02l-20-7 5 7-5 7z"];